import { stopLoad } from 'src/helper/webviewFun'
import React from 'react'
import ReactDOM from 'react-dom'
import App from 'src/core/app'
import { AppContainer } from 'react-hot-loader'
import 'react-vant/es/styles';
stopLoad()
const render = Component => {
  ReactDOM.render(
    <AppContainer>
      <Component />
    </AppContainer>,
    document.getElementById('root')
  )
}

render(App)
if (module.hot) {
  module.hot.accept('src/core/app', () => { render(App) })
}



// WEBPACK FOOTER //
// src/core/index.js